import { useTranslation } from "react-i18next";
import { useNavigate, useSearch } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";

import { MemberConsent } from "./MemberConsent";

/**
 * Top-level view for the `/consents` route: a member manages their own sharing
 * consent. Partners/admins view each member's consent state **inline in the
 * partner-group members list** (parity with the old app's group-detail page),
 * so there is no separate paste-a-UUID member-consent lookup here (K-2).
 *
 * Reached from an accepted invitation, `?next=` names the page the member came
 * from; consent autosaves, so "Continuer" simply goes back there, as the old
 * app's consent form does.
 */
export function ConsentsApp() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { next } = useSearch({ from: "/authed/consents" });

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">{t("consents.title")}</h1>
      <MemberConsent />
      {next && (
        <div className="flex justify-end">
          <Button onClick={() => void navigate({ to: next })}>
            {t("consents.continue")}
          </Button>
        </div>
      )}
    </div>
  );
}
